
<!-- 申请单 -->
<template>
    <div class="agencyCenterBox">
        <ul class="isOverNav">
            <li v-for="(value,index) in isOverNav" :key="index" :class="{active:isOverNavActive === index}" @click="handleNavActive(index)">{{value}}</li>
        </ul>
        <div class="situationList" v-if="todoList.length">
          <van-list
            ref="vanList"
            v-model="loading"
            :finished="finished"
            :finished-text="finishedText"
            :immediate-check="false"
            @load="onLoad"
            class="wrapper"
            >
            <div class="situationListItem" v-for="(item, index) in todoList" :key="index" @click="toApplicationDetele(index)">
              <div class="list_title">
                <div class="list_title_left">{{ item.title }}</div>
                <div class="list_title_right" :style="isOverNavActive == '0' ? 'color: #FF8C19' : isOverNavActive == '1' ? 'color: #00B76E' : 'color: #FF4D4D' ">{{ item.auditStatus == 0 ? '审核中' : item.auditStatus == 1 ? '审核通过' : '审核不通过' }}</div>
              </div>
              <div class="list_title_item">
                <div class="title">企业名称：</div>
                <div class="title_nav">{{ item.enterpriseName }}</div>
              </div>
              <div class="list_title_item">
                <div class="title">申请时间：</div>
                <div class="title_nav">{{ item.applyTime | filtTime }}</div>
              </div>
              <div class="list_title_item">
                <div class="title">当前诚信指数：</div>
                <div class="title_nav">{{ item.score }}分</div>
              </div>
              <div class="list_title_tag">
                <div class="list_title_tag_city line_border_blue"><div>{{ item.regionName }}</div></div>
                <div class="list_title_tag_guide line_border_green"><div>{{ item.industryCategoryName.slice(1, item.industryCategoryName.length - 1) }}</div></div>
              </div>
            </div>
          </van-list>
        </div>
        <div v-if="!todoList.length" class="situationListItems">
          <div class="imgBox">
            <img src="../../../../assets/integrity/ic_wuxingxi@2x.png" alt="">
            <div class="imgRemark">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import api from '../../../../service/modules/integrity';
    import { type } from '../../../../utils/configJson';

    export default {
        components: {
        },
        data () {
            return {
                isOverNav: [
                    '审核中',
                    '审核通过',
                    '审核不通过'
                ],
                isOverNavActive: 0, /** 当前tab下标 */
                pageIndex: 1,
                pageSize: 10,
                loading: false,
                finished: false,
                finishedText: '', // 待处理的提示
                todoList: [] // 待处理任务列表
            }
        },
        created () {
            this.getNotePageList();
        },
        methods: {
            getNotePageList () {
                api.notePageList({ auditStatus: this.isOverNavActive, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(res => {
                    if (res.ret === 0) {
                        let arr = res.data.list;
                        if (arr.length > 0) {
                            this.todoList = this.todoList.concat(arr);
                            this.finished = false;
                        } else {
                            this.finished = true;
                            this.finishedText = '没有更多了';
                        }
                        this.loading = false;
                    }
                })
            },
            onLoad () {
                ++this.pageIndex;
                this.getNotePageList()
            },
            handleNavActive (index) {
                this.isOverNavActive = index;
                this.pageIndex = 1;
                this.todoList = [];
                this.getNotePageList();
            },
            toApplicationDetele (ind) {
                this.$router.push({
                    path: '/integrity/applicationDetele',
                    query: {
                        taskId: this.todoList[ind].taskId,
                        type: this.todoList[ind].auditStatus,
                        showType: true,
                        title: this.todoList[ind].enterpriseName
                    }
                })
            }
        },
        filters: {
            filtTime (str) {
                if (str) {
                  var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                  var Y = date.getFullYear() + '-';
                  var M =
                      (date.getMonth() + 1 < 10
                          ? '0' + (date.getMonth() + 1)
                          : date.getMonth() + 1) + '-';
                  var D =
                      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                  var h =
                      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                  var m =
                      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                      ':';
                  var s =
                      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                  let strDate = Y + M + D;
                  return strDate;
                } else {
                  return str;
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .agencyCenterBox{
        width: 100%;
        height: 100%;
        padding: 0 12px;
        background-color: #FBFBFB;

        .isOverNav{
            height: 58px;
            width: 100%;
            position: fixed;
            background: #FBFBFB;
            z-index: 99;

            >li{
                height: 30px;
                margin-top: 16px;
                margin-right: 24px;
                font-size: 14px;
                color:rgba(51,51,51,1);
                text-align: center;
                line-height: 35px;
                border-top: 2px solid transparent;
                border-bottom: 2px solid transparent;
                float: left;
            }

            >li.active{
                color: #36B374;
                border-bottom-color: #36B374;
                font-weight: bolder;
            }
        }

        .isOverNav::after{
                content: '';
                display: block;
                clear: both;
        }

        .situationListItems {
          height: 92%;
          display: flex;
          justify-content: center;
          align-items: center;
          .imgBox {
            width:74px;
            img {
              display: inline-block;
              width:74px;
              height:62px;
            }
            .imgRemark {
              font-size: 14px;
              font-weight: 400;
              color: #999;
              margin-top: 24px;
              text-align: center;
            }
          }
        }
        .situationList {
          padding-top: 58px;
          width: 100%;
          height: 100%;
          .situationListItem {
            background: #fff;
            padding: 16px;
            margin-bottom: 12px;
            .list_title {
              display: flex;
              justify-content: space-between;
              margin-bottom: 16px;
              .list_title_left {
                font-size:14px;
                font-weight:600;
                color: #333333;
              }
              .list_title_right {
                font-size:14px;
                font-weight:400;
              }
              .list_title_right_warning {
                color: #FF8C19;
              }
              .list_title_right_gran {
                color: red;
              }
            }
            .list_title_item {
              display: flex;
              justify-content: left;
              font-size: 14px;
              font-weight:400;
              margin-bottom: 8px;
              .title {
                color: #999999;
              }
              .title_nav {
                color: #333333;
                margin-left: 2px;
              }
            }
            .list_title_tag{
              display: flex;
              justify-content: left;
              margin-left: -8px;
              .list_title_tag_city {
                line-height: 18px;
                font-size: 12px;
                height: 18px;
                margin-left: 4px;
                -webkit-transform: scale(0.84);
                margin: 0px 3px 0 3px;
                padding: 0 3px 2px 3px;
                text-align: center;
                color: #2283E6;
                // margin-right: 4px;
              }
              .list_title_tag_guide {
                line-height: 18px;
                font-size: 12px;
                height: 18px;
                margin-left: 4px;
                -webkit-transform: scale(0.84);
                margin: 0px 3px 0 3px;
                padding: 0 3px 2px 3px;
                text-align: center;
                color: #36B374;
              }
            }
            // .list_title_tag {
            //   display: flex;
            //   align-items: left;
            //   font-size: 12px;
            //   .list_title_tag_city {
            //     color: #2283e6;
            //     margin-right: 8px;
            //     div {
            //       -webkit-transform: scale(0.84);
            //       max-width: 108px;
            //       overflow: hidden;
            //       text-overflow: ellipsis;
            //       white-space: nowrap;
            //       height: 14px;
            //       font-size: 10px;
            //       line-height: 14px;
            //       text-align: center;
            //       padding: 0 4px 0 4px;
            //     }
            //   }
            //   .list_title_tag_guide {
            //     color: #36B374;
            //     div{
            //       height: 14px;
            //       font-size: 10px;
            //       line-height: 14px;
            //       text-align: center;
            //       padding: 0 4px 0 4px;
            //       -webkit-transform: scale(0.84);
            //     }
            //   }
            // }
          }
        }
    }
</style>
